import React from "react";
import "./About.css";
import logo from "../../assets/logo.jpg";

const AboutPage = () => {
  return (
    <div className="about-wrapper">

      {/* 🔥 MAIN SEO H1 */}
      <h1 className="about-heading">
        About LushDesire – Buy Sex Toys Online in India with 100% Privacy
      </h1>

      {/* LOGO */}
      <div className="about-logo">
       <img
  src={logo}
  alt="LushDesire – India’s Trusted Online Sex Toys Store"
  loading="lazy"
/>

      </div>

      <div className="about-content">

        {/* INTRO */}
        <p>
          <strong>LushDesire</strong> is a trusted Indian online platform
          dedicated to helping men, women, and couples explore intimacy with
          confidence, comfort, and complete privacy. We specialize in
          <strong> premium, legal sex toys in India</strong>, delivered discreetly
          to your doorstep.
        </p>

        {/* SECTION */}
        <h2>Who We Are</h2>
        <p>
          Founded with a vision to normalize conversations around personal
          wellness and intimacy, LushDesire was created to offer a safe,
          judgment-free space where adults can shop for intimate products
          without embarrassment.
        </p>

        <p>
          We understand that buying sex toys online in India requires trust.
          That’s why we focus on transparency, product quality, and customer
          privacy above everything else.
        </p>

        {/* SECTION */}
        <h2>Our Belief in Privacy & Discretion</h2>
        <p>
          Privacy is not a feature for us — it is our foundation. Every order
          placed on LushDesire is shipped in <strong>100% unbranded and discreet
          packaging</strong>. Billing statements use neutral names, and customer
          data is always protected.
        </p>

        {/* SECTION */}
        <h2>What We Offer</h2>
        <p>
          Our curated collection includes a wide range of
          <strong> sex toys for men, women, and couples</strong>, including
          vibrators, masturbators, couple toys, lubricants, and intimate
          wellness accessories. All products are made from body-safe materials
          and are fully legal in India.
        </p>

        {/* SECTION */}
        <h2>Why Choose LushDesire?</h2>
        <ul>
          <li>✔ Buy sex toys online in India safely</li>
          <li>✔ 100% discreet delivery across India</li>
          <li>✔ Cash on Delivery (COD) available</li>
          <li>✔ Trusted by thousands of Indian customers</li>
          <li>✔ Privacy-first support & secure checkout</li>
        </ul>

        {/* SECTION */}
        <h2>Our Mission</h2>
        <p>
          Our mission is to empower individuals and couples to embrace intimacy
          without fear or shame. We aim to become India’s most trusted destination
          for sexual wellness by combining education, quality products, and
          absolute discretion.
        </p>

        {/* BRAND TRUST */}
        <h3>LushDesire – India’s Growing Adult Wellness Brand</h3>
        <p>
          Whether you are exploring for the first time or looking to enhance
          your intimate life, <strong>LushDesire.in</strong> is here to support
          you with care, respect, and trust.
        </p>

      </div>
    </div>
  );
};

export default AboutPage;
